import { render, staticRenderFns } from "./happily-village.vue?vue&type=template&id=2607d6ca&scoped=true&"
import script from "./happily-village.vue?vue&type=script&lang=js&"
export * from "./happily-village.vue?vue&type=script&lang=js&"
import style0 from "./happily-village.vue?vue&type=style&index=0&id=2607d6ca&lang=scss&scoped=true&"
import style1 from "./happily-village.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607d6ca",
  null
  
)

export default component.exports